/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('card.cardStatistic', function (el) {
        var titleValues = el.querySelectorAll('.title__value');
        titleValues.forEach(function (titleValue) {
            var initialValue = parseFloat(titleValue.textContent);
            var count = 0;
            if (Number.isInteger(initialValue)) {
                setInterval(function () {
                    if (count < initialValue) {
                        titleValue.textContent = (++count).toString();
                    }
                    else {
                        clearInterval();
                    }
                }, 3);
            }
            else if (!isNaN(initialValue)) {
                setInterval(function () {
                    if (count < initialValue) {
                        titleValue.textContent = count.toFixed(1);
                        count += 0.1;
                    }
                    else {
                        clearInterval();
                    }
                }, 2);
            }
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
